import {DrawerFilters, TabName} from "..";
import {ACTIVE_AND_UPCOMING_STATUSES, FINISHED_STATUSES} from "../constants";

export function getDefaultFilters(activeTab: TabName): DrawerFilters {
    const defaultStatuses = activeTab === TabName.ActiveAndUpcoming ? ACTIVE_AND_UPCOMING_STATUSES : FINISHED_STATUSES;
    return {statuses: defaultStatuses, city_id: undefined, polygon_location: undefined};
}
